export default __webpack_public_path__ + "static/media/left-leaf.90deabda.svg";